import { render, staticRenderFns } from "./new-dialog.vue?vue&type=template&id=1a562f5c&scoped=true&"
import script from "./new-dialog.vue?vue&type=script&lang=ts&"
export * from "./new-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./new-dialog.vue?vue&type=style&index=0&id=1a562f5c&lang=scss&scoped=true&"
import style1 from "./new-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a562f5c",
  null
  
)

export default component.exports